import * as React from "react";

const SvgCursorclick = ({ color, size }) => (
  <svg
    viewBox="0 0 24 24"
    width={`${24 * (size || 1)}px`}
    height={`${24 * (size || 1)}px`}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
      stroke={color}
      strokeWidth={2}
    >
      <path d="M15.496 15.496 13.694 20l-3.603-9.91 9.91 3.604zM15.496 15.496 20 20M8.459 4l.699 2.61M6.61 9.158 4 8.459M14.55 5.632l-1.911 1.911M7.543 12.639 5.632 14.55" />
    </g>
  </svg>
);

export default SvgCursorclick;
